import React from 'react';
import { Grid, Typography } from '@mui/material';
import AddUser from './UserAdd';

const UserListHeader = ({ refetch }: { refetch: () => {} }) => {
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography variant="h3" component="h3" gutterBottom>
          Foydalanuvchilar ro'yxati
        </Typography>
      </Grid>
      <Grid item>
        <AddUser refetch={refetch} />
      </Grid>
    </Grid>
  );
}

export default UserListHeader;
